import React from 'react'
import { object, string } from 'prop-types'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { makeImgResizerUrl } from '@jelly/utils'
import { Link } from '@jelly/ui'
import { SocialProfileButtons } from '@jelly/components'
import { SponsoredLink } from '../SponsoredLink'

const SponsorDetailsContainer = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.grey01};
	box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
	display: block;
	font-weight: 300;
	height: auto;
	margin-bottom: 20px;

	${({ theme }) => theme.MQ.M} {
		width: 300px;
	}
`
const HeaderWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid ${({ theme }) => theme.colors.grey01};
	padding: 10px 15px;
`
const SponsoredLogo = styled.img`
	display: inline-block;
	height: auto;
	max-height: 30px;
	max-width: 120px;
	width: auto;
`
const SponsorBio = styled.div`
	box-sizing: content-box;
	color: ${({ theme }) => theme.colors.gray[600]};
	display: block;
	font-size: 12px;
	padding: 10px 15px;
`

const SponsorName = styled.div`
	color: ${({ theme }) => theme.colors.primary};
	font-weight: 600;
	font-size: 14px;
	word-wrap: break-word;
`

const SponsorWebsite = styled(Link)`
	text-decoration: underline;
`

const NameAndSite = styled.div`
	border-left: 1px solid ${({ theme }) => theme.colors.grey01};
	display: block;
	font-size: 12px;
	padding-left: 15px;
	margin-left: 15px;
`
const SocialButtonContainer = styled.div`
	display: flex;
	margin: 0 15px 5px 15px;
`

export const SponsorDetails = ({ thumbnail, name, bio, social, rel = 'nofollow sponsored' }) => {
	const {
		colors: { greyM1, white },
	} = useTheme()
	return (
		<SponsorDetailsContainer>
			<HeaderWrapper>
				<SponsoredLink sponsorLink={social.website} sponsorName={name}>
					<SponsoredLogo
						alt={name}
						className="lazyload"
						data-src={makeImgResizerUrl({ src: thumbnail, method: 'h', h: '50-png' })}
					/>
				</SponsoredLink>
				<NameAndSite>
					<SponsorName>{name}</SponsorName>
					<SponsorWebsite href={social.website} rel={rel} variant="secondary">
						View Website
					</SponsorWebsite>
				</NameAndSite>
			</HeaderWrapper>
			<SponsorBio>{bio}</SponsorBio>
			{social && (
				<SocialButtonContainer>
					<SocialProfileButtons
						buttons={social}
						backgroundColor={greyM1}
						name={name}
						color={white}
						rel={rel}
					/>
				</SocialButtonContainer>
			)}
		</SponsorDetailsContainer>
	)
}

SponsorDetails.propTypes = {
	bio: string,
	name: string.isRequired,
	social: object.isRequired,
	sponsorType: string.isRequired,
	thumbnail: string.isRequired,
	rel: string,
}
